<template>
  <div class="container">
    <div class="mb-3 row">
      <a
        class="d-inline float-right mx-2 mt-1"
        v-if="!AddMode && !EditMode"
        @click="
          AddMode = !AddMode
          addnew()
        "
        title="افزودن پرسشنامه جدید"
      >
        <h4>
          <i class="fas Pointer fa-plus text-success" style="color: var(--logo-color) !important"></i>
        </h4>
      </a>
      <a
        v-if="AddMode || EditMode"
        class="d-inline float-right mx-2 mt-1"
        href="javascript:;"
        @click="
          AddMode = false
          EditMode = false
        "
        title="لغو افزودن"
      >
        <h4>
          <i class="fas fa-times text-danger"></i>
        </h4>
      </a>
    </div>
    <div v-if="Surveys.length < 1 && !AddMode" class="col-12 p-4 border Rounded">
      <h4>پرشسنامه ای ثبت نشده است.</h4>
    </div>
    <div v-else-if="Surveys.length > 0 && !AddMode && EditMode != true" class="col-12 p-4">
      <div class="row mt-3">
        <div v-for="(survey, index) in Surveys" :key="index" class="col-md-3 col-12 p-2">
          <CardBox>
            <template v-slot:cardbox-icon1><i class="fad fa-poll-people"></i></template>
            <template v-slot:b-dropdown-item>
              <b-dropdown-item
                @click="
                  Edit(survey)
                  EditMode = !EditMode
                "
                href="#"
                class="text-center"
                >مشاهده/پاسخ دادن</b-dropdown-item
              >
              <b-dropdown-item @click="DeleteQuestion(survey)" href="#" class="text-center">حذف</b-dropdown-item>
            </template>
            <template v-slot:cardbox-body>
              <p class="card-title text-center">
                <span>نام پرشسنامه: </span>
                {{ survey.Name }}
              </p>
              <!-- <p class="card-text detail mt-4"> سمت : {{person.tblcomboGrp1SematName}}</p> -->
              <p class="card-text detail">تاریخ ایجاد : {{ survey.Date }}</p>
              <!-- <p v-if="person.SendSmsTo && person.SendSmsTo!=false" class="card-text detail text-info">امکان ارسال پیامک</p> -->
            </template>
          </CardBox>
        </div>
      </div>
    </div>
    <div v-else-if="AddMode" class="col-12 p-4">
      <div class="row">
        <div id="$route.name" class="col-lg-8 col-12">
          <SearchableCombo :edit="false" :grp="18" :code="null" @ResultCombo="GetResultSurvey" :rownumintable="3" :defaultvalue="null" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Surveyinput'" :keyItem="'Surveyinput'" :ClassProps="'required'"> </SearchableCombo>
        </div>
        <div class="col-lg-4 col-12">
          <button class="btn btn-success" @click="insertToDb">ثــبت پــرسشنامه</button>
        </div>
      </div>
    </div>
    <div v-if="Surveys.length > 0 && EditMode == true" class="col-12">
      <div class="row">
        <div class="col-12 row mt-2 p-2" v-for="(item, index) in QA" :key="item.id">
          <div class="col-lg-6 col-12">
            {{ item.name }}
          </div>
          <div class="col-lg-6 col-12">
            <!-- {{ QA[index] }} -->
            <input v-if="QA[index].code == 0" type="text" class="form-control" v-model="QA[index].answer" />
            <div v-else class="form-control">
              <div class="w-100 text-center">
                <div class="custom-control custom-switch">
                  <small id="LbltblComboGrpId50" class="ml-2"> بلی</small>
                  <input type="checkbox" class="custom-control-input InputText" :id="'ShowInSlides' + index" @click="BuildBool(index)" :checked="QA[index].answer == 'true'" />
                  <label class="custom-control-label mr-2 Pointer" :for="'ShowInSlides' + index"> </label>
                  <small class="mr-5"> خیر</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-12 mt-3"></div>
        <div class="col-lg-4 col-12 mt-">
          <button class="btn btn-warning w-100" @click="EditMode = false">انصراف</button>
        </div>
        <div class="col-lg-4 col-12 mt-">
          <button class="btn btn-success w-100" @click="submitSurvey()">ثـبـت</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CardBox from '@/components/CardBox/CardBox.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'

export default {
  data() {
    return {
      QA: [],
      AddMode: false,
      EditMode: false,
      DataAxiosAdd: {
        Method: 'POST',
        Action: 'Survey/AddCustomerSurvey',
        ArryfildValue: {
          TblCustomerId: this.CustomerId,
          TblTblComboGrp18SurveyID: 0,
          TblUsergrpInsert: this.$session.get('UserInfo').tblUserGrpId,
        },
      },
      DataAxiosEdit: {
        Method: 'POST',
        Action: 'Survey/AddCustomerSurvey',
        ArryfildValue: {},
      },
    }
  },
  props: ['CustomerId', 'Surveys'],
  components: { CardBox, SearchableCombo },
  methods: {
    addnew() {
      this.DataAxiosAdd.ArryfildValue.TblTblComboGrp18SurveyID = null
    },
    GetResultSurvey(data) {
      this.DataAxiosAdd.ArryfildValue.TblTblComboGrp18SurveyID = data.id
    },
    insertToDb() {
      this.$ValidForm(this.$route.name)
      this.$PostData(this.DataAxiosAdd).then((result) => {
        if (result.status == 'success') {
          this.$mySweetDefaultTost('عملیات موفق', 'پرشسنامه جدید با موفقیت اضافه شد', 'success', 2000)
          this.$emit('Inserted', {
            done: 'OK',
            activeTab: 4,
          })
          this.AddMode = false
        } else {
          this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی بوجود امده است دوباره تلاش کنید', 'error', 2000)
        }
      })
    },
    Edit(data) {
      this.QA = []
      var Daxios = {
        Action: 'Survey/GetAQ',
        Method: 'POST',
        ArryfildValue: { Id: data.Id },
      }
      this.$PostData(Daxios).then((result) => {
        this.QA = result
      })
    },
    submitSurvey() {
      var DataAxiosAnswer = {
        Action: 'Survey/Answer',
        Method: 'POST',
        ArryfildValue: {},
      }
      this.QA.forEach((element) => {
        element.tblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
      })
      DataAxiosAnswer.ArryfildValue = this.QA
      this.$PostData(DataAxiosAnswer).then((result) => {
        if (result.status == 'success') {
          this.$mySweetDefaultTost('عملیات موفق', 'پرشسنامه  با موفقیت بروز شد', 'success', 2000)
          this.EditMode = false
        } else {
          this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی بوجود امده است دوباره تلاش کنید', 'error', 2000)
        }
      })
    },
    DeleteQuestion(data) {
      var DataAxiosDelete = {
        Action: 'Survey/Delete',
        Method: 'POST',
        ArryfildValue: { Id: data.Id },
      }
      this.$PostData(DataAxiosDelete).then((result) => {
        if (result.status == 'success') {
          this.$mySweetDefaultTost('عملیات موفق', 'پرشسنامه  با موفقیت حذف شد', 'success', 2000)
          this.EditMode = false
          this.$emit('Inserted', {
            done: 'OK',
            activeTab: 4,
          })
        } else {
          this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی بوجود امده است دوباره تلاش کنید', 'error', 2000)
        }
      })
    },
    BuildBool(index) {
      this.QA[index].answer == 'true' ? (this.QA[index].answer = 'false') : (this.QA[index].answer = 'true')
    },
  },
}
</script>
